import React, { useState, useEffect } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink, useNavigate } from 'react-router-dom';
import HeadingCp from '../components/HeadingCp';
import Modal from '../components/Modal';
import ShortDateFormat from '../components/ShortDateFormat';
import PhoneNumber from '../components/PhoneNumber';

const statuses = {
  Complete: 'text-green-700 bg-green-50 ring-green-600/20',
  'In progress': 'text-gray-600 bg-gray-50 ring-gray-500/10',
  Archived: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20',
}


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const TechWipList = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);
  
  useEffect(() => {
    setLoading(true);
    const fetchWipList = async () => {
      try {
        const response = await axios.get(`${apiUrl}/wip_crud.php?getWipTechList=true`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        if(response.data[0] === 'success')
        {
          const jobs = Array.isArray(response.data[1]) ? response.data[1] : [];
          setJobs(jobs);
        }
        else{
          toast.error(response.data.error, { position: "top-center" });
        }
        
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session expired. Please login again.", { position: "top-center" });
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchWipList();
  }, [apiUrl, navigate]);

  const handleActivation = async(id, status) => {
    const bodyData = {
      status: "activate_wip",
      schedule_id: id
    };
    if(status === 'Active')
    {
      navigate(`/t/twipdetails/${id}`);
    }
    else
    {
      try {  
        const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' },
        }); 
        if (response.data[0] === 'success') 
        {
            navigate(`/t/twipdetails/${id}`);
        } 
        else 
        {
          toast.info("Failed to access this job.", { position: "top-center" });
        }
      } 
      catch (error) 
      {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
            position: "top-center",
          });
        }
      } 
      finally 
      {
        setLoading(false);
      }      
    }

  }

 return (
    <>
    <HeadingCp label={"Job Queue"}/>

    <ul role="list" className="divide-y divide-gray-100">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {jobs.map((wip) => (
          <div key={wip.schedule_id}
            onClick={() => handleActivation(wip.schedule_id, wip.status)}
            className={classNames(
              `relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2
               focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400`,
            )}>
            <div className="flex-shrink-0 text-xs">
              <div className='text-sm'>{wip.job_number}</div>
              <span className={`rounded bg-blue-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 
                  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                   focus-visible:outline-indigo-600`} >
                {wip.type}
              </span>
              <p className='py-1'>{wip.start_time ? wip.start_time : ''}</p>
              <p>{wip.schedule_from ? wip.schedule_from : <ShortDateFormat date={wip.schedule_from} />}</p>
            </div>

            <div className="min-w-0 flex-1">
                <span aria-hidden="true" className="absolute inset-0" />
                <p className="text-sm font-medium text-green-700">{wip.customer_name}</p>
                <p className="truncate text-sm text-gray-500">{wip.job_site}</p>
                <p className="truncate text-xs text-gray-500">{wip.job_description}</p>
                <p className="truncate text-xs text-yellow-700">Coordinator Comment: {wip.user_comment}</p>
            </div>
          </div>
        ))}
      </div>
    </ul>
    </>
  )
}

export default TechWipList